import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";
import { OpenableProps } from "@/types";
import { createVersionApiStore, projectStore } from "@/hooks";
import { SwitchInput, PanelCard, TextButton } from "@/components/common";
import { ProjectFilesInput } from "@/components/project/save";


/**
 * Displays inputs for uploading a new version.
 */
const __default__ = {
  name: "UploadNewVersion",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const files = ref<File[]>([]);
const replaceAllArtifacts = ref(false);

/**
 * Resets component data.
 */
function handleReset() {
  createVersionApiStore.handleReset();
  files.value = [];
  replaceAllArtifacts.value = false;
}

/**
 * Uploads a new project version.
 */
function handleSubmit() {
  createVersionApiStore
    .handleImport(
      projectStore.projectId,
      projectStore.versionId,
      files.value,
      true,
      replaceAllArtifacts.value
    )
    .then(() => handleReset());
}

watch(
  () => props.open,
  (open) => {
    if (!open) return;

    handleReset();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { subtitle: "Select files to upload to the current project version." }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        block: "",
        disabled: !files.value || files.value.length === 0,
        label: "Upload Project Files",
        color: "primary",
        "data-cy": "button-upload-files",
        onClick: handleSubmit
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ProjectFilesInput), {
        modelValue: files.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((files).value = $event)),
        "data-cy": "input-files-version"
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(SwitchInput), {
        modelValue: replaceAllArtifacts.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((replaceAllArtifacts).value = $event)),
        label: "Replace all artifacts"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})